export default __webpack_public_path__ + "static/quentin-webfont-c60ecfe97b028285cff6507ab4ff4c22.woff";